import Modal from 'components/containers/Modal/Modal';
import Button from 'components/generics/buttons/Button';
import DebtForm from 'components/generics/forms/DebtForm';
import Transition from 'components/transitions/Transition';
import React, { HTMLAttributes, useState } from 'react';
import classes from './index.module.scss';

const LandaFinancingFormMobile = ({
  className,
}: HTMLAttributes<HTMLDivElement>) => {
  const [open, setOpen] = useState(false);
  return (
    <Transition className={className}>
      <Button
        className={classes.buyChip}
        onClick={() => setOpen(true)}
      >
        Invest
      </Button>
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        className={classes.buyDialogMobile}
      >
        <DebtForm />
      </Modal>
    </Transition>
  );
};

export default LandaFinancingFormMobile;
